import {ReportRow} from '../ReportTypes';
import {getSavedReportURLByReportType} from '../../../../components/insights/saved_report_util';
import {UseHistoryType} from '../ReportsPage';
import {canOpenReportBuilder} from '../../../../components/ai-report-builder/reportBuilderGate';

/** Reports generated in the report builder re-open there; every other report opens in the report page
 * it was built in.
 *
 * The gate is re-checked here rather than trusted from the report: a report keeps its origin forever,
 * but the builder can be turned off afterwards, and routing into a surface that then redirects home
 * would strand the report. With the gate closed an AI report falls back to the standard page, which
 * renders it like any other saved report. */
export const openReport = (report: ReportRow, history: UseHistoryType): void => {
	if (report.source === 'AI' && canOpenReportBuilder()) {
		history.push(`/report-builder/${report.id}`);
		return;
	}
	const path = getSavedReportURLByReportType(report.type, report.id);
	history.push(path);
};
